import template from './invoicesList.template.html';

export default {
  template,
  bindings: {
    invoices: '=',
    onClick: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, listService, dateTimeService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.CurrentTimeFormat = null;
      ctrl.list = listService;
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.list.setData(ctrl.invoices);
        ctrl.list.setOrderBy('-date');
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.getTotal = (invoiceTotal) => {
        return (invoiceTotal / 100).formatWithCurrency({ symbol: '$' }, 2);
      };

      ctrl.getDate = (invoiceDate) => {
        return dateTimeService.getFormattedDate(invoiceDate);
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.invoices && changes.invoices.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
